// extracted by css-extract-rspack-plugin
export default {"FCRATerms":"sputnik__FCRATerms__Mt3ge","fcraTerms":"sputnik__FCRATerms__Mt3ge","FCRATerms-list":"sputnik__FCRATerms-list__zUq_v","fcraTermsList":"sputnik__FCRATerms-list__zUq_v"};